/*
 * @Author: jiansuiwang@rastar.com
 * @Date: 2023-08-17 15:59:55
 * @LastEditors: jiansuiwang@rastar.com
 * @LastEditTime: 2023-11-09 16:53:04
 * @FilePath: \sea-page-game\src\utils\Ciphertext.js
 */
import CryptoJS from "crypto-js";
import JSEncrypt from "jsencrypt";
import { getGamekeyV2 } from "./sign";
import Base from "./base";

let key = "";

// 根据url上appid 生成明文密钥
const urlData = Base.parseUrl(window.location.href);
key = getGamekeyV2(urlData.appid);
function generateIv() {
  let library = CryptoJS.MD5(key).toString();
  return library.substring(0, 16);
}
let iv = generateIv();
key = CryptoJS.MD5(key).toString();
iv = CryptoJS.enc.Utf8.parse(iv);

let Ciphertext = {
  // AES加密
  AESkey(val) {
    var mi = CryptoJS.AES.encrypt(
      JSON.stringify(val),
      CryptoJS.enc.Utf8.parse(key),
      {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    return mi.toString();
  },
  // ASE 解密
  Decrypt(encryptData) {
    const encryptedText = CryptoJS.enc.Base64.parse(encryptData);
    const decryptedData = CryptoJS.AES.decrypt(
      { ciphertext: encryptedText },
      CryptoJS.enc.Utf8.parse(key),
      {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    return decryptedData.toString(CryptoJS.enc.Utf8);
  },
  // RSA加密
  RSAkey() {
    let pubKey =
      "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDihGcOW570q+UDN0UgTIcVUOzG486vzXGSjYw7LUXXgYprUZ6e2q0aW37LWeOEByi5H3JJUYiNRH6FxOGoNEjqV5f8qFTcf47oylUBkJQRy8Q6X3X1GnjT6G1YOsqVOlSWt6OZQTRK2vqVMr5C08tELUUmq2ZeOmh0xdInBGl81wIDAQAB";
    let keystring = key + "``" + iv;
    let encrypt = new JSEncrypt();
    encrypt.setPublicKey(pubKey);
    return encrypt.encrypt(keystring);
  },
  // 私钥加签，公钥验签
  shaSign(mi, encrypted) {
    let privkey =
      "MIICXQIBAAKBgQC7sRjnlH/iGMc1Ln3iMtfTJEQUsCMrGIgEr9vdp4swSeAtsgienL166t5WMh7AD80RECeguJ0JHiqehwfINHTAKf8dTExTrdkSEGkFFLx3ubDbDrDg/nLBOm/xxryozrIAfc4UhRXdM7Bx2tw/3x5Ky4tAuF7ZPE9JKm6WmOjKMwIDAQABAoGAAoGDzpu59V/VUQ102s9I+GW0jv4nCg1Cy6U5b0UsY5Go75M/8DYxhXGbVFVI+dF8MG0hylCMsDF56jHtVav1nxFVhGjtTWt0zDDnBCf/YuPvw2M+vQ/f6Ku9e4tNL/wWZi6pSH1I2tU66JrN7O6sKpNoXbiRghojllv2NLuHGDECQQDhA5xpgblplO8iLIrPXy4UkD1ZxMWsxPnQ07AP3hiqu2e6ZXoZNcmNeq4fYIcXU56qQxOnOwfBTmBY4cSHWVa7AkEA1YnEoey7Zdkok8ViRqsk+qjcBaKU2XDDtjgdNMDt+bh+HyPOClkqvNBKZjCbpBGx0EGzq0IMruEqfIn7+/Xu6QJBALYJ0dSZmoMMdppTJsm12vXP65JgWvv3L5P+boWnzJTzoGtwBWO33COViKDh2ujIQajFM3UrkI6W9eNyYyiM4lkCQQC7a3TjLjV4efYsZLUSE4qcWnLqmz0L7/ZGy8+OirsUUAKacEGaQZLKMALs2ELy6PjpMZFxgcJCB6zTrAQ3rC5pAkBQMjvTz6QZVswsVpIhXSRV3fRAs3F0ylerigAEi91f2DsfoORbV63FtxI5496hQ0QZ47wharQH1r40Xee0FCAo";
    let sign = new JSEncrypt();
    sign.setPrivateKey(privkey);
    return sign.sign(
      CryptoJS.SHA256(mi + encrypted).toString(),
      CryptoJS.SHA256,
      "sha256"
    );
  },
};
export default Ciphertext;
